import {
    conversationList,
    conversationView,
    conversationTextShortDescription,
    conversationTextLongDescription
} from "./conversationApi";

export const conversationLoader = async () => {
    const conversationListRes = await conversationList();
    const conversations = conversationListRes.data;
    return { conversations };
};


export const conversationDetailLoader = async ( request ) => {
    const conversationEntityId = request.params.conversationEntityId;
    const conversationRes = await conversationView(conversationEntityId);
    const conversation = conversationRes.data;
    const longDescriptionRes = await conversationTextLongDescription(
        conversationEntityId);
    const longDescription = longDescriptionRes.data;
    return { conversation , longDescription };
};

export const conversationListLoader = async () => {
    const conversationListRes = await conversationList();
    const conversations = conversationListRes.data;
    for (let conversation of conversations) {
            const shortDescriptionRes = await conversationTextShortDescription(conversation.conversationEntityId);
            conversation.shortDescription = shortDescriptionRes.data;
        }
    console.log({conversations});
    return { conversations };
}
